import { render } from "./message-file.vue?vue&type=template&id=5b1e1f47&scoped=true&ts=true"
import script from "./message-file.vue?vue&type=script&lang=ts"
export * from "./message-file.vue?vue&type=script&lang=ts"

import "./message-file.vue?vue&type=style&index=0&id=5b1e1f47&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1e1f47"]])

export default __exports__